module.exports = __webpack_public_path__ + "img/placeholder-rect.16171fc5.jpg";